
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import QmsDropdown from "components/ui/qms-dropdown/QmsDropdown";
import "./search-bar-with-type.css"

const SearchbarWithType = (props) => {
    const { onSelectedTypeChange, searchButtonClick } = props
    const [selectedType, setSelectedType] = useState(null)
    const [inputValue, setInputValue] = useState('');
    const [validationError, setValidationError] = useState('');
    const multiple = {
        key: "select",
        value: [
            {
                agentCode: "customer_name",
                agentName: "Customer Name"
            },
            {
                agentCode: "mobile_number",
                agentName: "Mobile Number"
            },
            {
                agentCode: "email",
                agentName: "Email"
            }
        ]
    }

    const handleTypeChange = (type) => {
        setSelectedType(type);
        onSelectedTypeChange(type, '')
        setInputValue('');
        setValidationError('');
    };

    const handleInputChange = (event) => {

        switch (selectedType) {
            case 'Customer Name':
                if (/^[A-Za-z, ]+$/.test(event.target.value)) {
                    setInputValue(event.target.value);
                    onSelectedTypeChange("customer_name", event.target.value)
                    //  setValidationError('');
                } else if (event.target.value.length === 0) {
                    onSelectedTypeChange("", "")
                    setInputValue("");
                    setSelectedType("")
                }
                break;
            case 'Mobile Number':
                if (/^[0-9]{1,10}$/.test(event.target.value)) {
                    setInputValue(event.target.value);
                    onSelectedTypeChange("mobile_number", event.target.value)
                    //  setValidationError('');
                } else if (event.target.value.length === 0) {
                    onSelectedTypeChange("", "")
                    setInputValue("");
                    setSelectedType("")
                }
                break;

            case 'Email':

                if (/^[a-zA-Z0-9!@#$%^&*()._+-]*$/.test(event.target.value) && event.target.value.length != 0) {
                    setInputValue(event.target.value);
                    onSelectedTypeChange("email", event.target.value)
                    //   setValidationError('');
                } else if (event.target.value.length === 0) {
                    onSelectedTypeChange("", "")
                    setInputValue("");
                    setSelectedType("")
                }
                break;
            default:
                //   setValidationError('');
                break;
        }
    };

    const validateInput = () => {
        if (selectedType && inputValue) {

            switch (selectedType) {
                case 'Customer Name':
                    searchButtonClick(true, "search_bar")
                    break;
                case 'Mobile Number':
                    if (inputValue.length === 10) {
                        searchButtonClick(true , "search_bar")
                        setValidationError("")
                    } else {
                        setValidationError("Please enter a valid Mobile Number.")
                    }
                    break;

                case 'Email':

                    if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/.test(inputValue)) {
                        searchButtonClick(true, "search_bar")
                        setValidationError("")
                    } else {
                        setValidationError("Please enter a valid email address.")

                    }
                    break;
                default:
                    setValidationError('');
                    break;
            }
        }else if (!selectedType && !inputValue){
            searchButtonClick(true, "search_bar")
        }

    };

    const placeholderName = (value) => {
        if (value === 'Customer Name') {
            return 'First Name';
        } else {
            return value;
        }
    }

    return (
        <>
            <div className='row ' >
                <div className=' my-2 col-4 col-lg-4 pr-0'>
                    <QmsDropdown
                        title={multiple.key}
                        item={multiple.value}
                        menuItemStyle='d-flex justify-content-between align-items-center'
                        dropdownStyle=' font-size-14 '
                        datachnages={handleTypeChange}
                        selectedTypes={selectedType}
                    />
                </div>
                <div className='col-8 col-lg-8 pl-0'>
                    <Form className="d-flex my-2 sm-w-50 ">
                        <Form.Control
                            type="search"
                            placeholder={`Search By ${selectedType ? placeholderName(selectedType) : " "}`}
                            value={inputValue}
                            onChange={handleInputChange}
                            className="rounded search-field"
                            aria-label="Search"
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    e.preventDefault();
                                }

                            }}
                        />
                        <Button className='ml-1 rounded-pill' onClick={validateInput} >
                            <i class="fa fa-search font-size-18"></i>
                        </Button>
                    </Form>
                </div>
                <p className='pl-3 text-danger'>{validationError}</p>

            </div >
            <div>
                {/* <p style={{ color: 'red', paddingLeft: '191px' }}>adsd asfsd gdfgdf</p> */}
            </div>
        </>
    );
};

export default SearchbarWithType;
